import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const PROCESS_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.Process.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
];

export const PROCESS_CONFIG = {
  entityName: 'Process',
  localizationKey: 'Controlling::Entity.Process',
  fields: PROCESS_FIELDS,
  permission: 'ControllingProcess.Processes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Processes + MENU_NAME_SUFFIX,
};
